import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Col, Row, Switch, Tooltip } from "antd";
import { Button } from "Components/General/Button";
import { I18N_NS } from "Config/i18n";
import { observer } from "mobx-react";
import { withTranslation, WithTranslation } from "react-i18next";
import { projectsDataStore, userInfoStore } from "Stores";
import { AdditionalOptions, DownloadMode, LedIndicatorsOptions } from "./FileDownloadStore";

interface DownloadOptionsProps extends WithTranslation {
  downloadMode: DownloadMode;
  downloadOptions: { [key in AdditionalOptions]?: boolean };
  options: { [key in LedIndicatorsOptions]?: boolean };
  filesAmount: number;
  onChange: (option: AdditionalOptions) => void;
  onBack: () => void;
  onDone: () => void;
}

export const DownloadOptions = withTranslation(I18N_NS.PROJECT)(
  observer(({ t, downloadMode, downloadOptions, filesAmount, onChange, onBack, onDone }: DownloadOptionsProps) => {
    let qrToolTip: string = null;
    if (projectsDataStore.isQRForce()) {
      if (projectsDataStore.isQrMDFilter()) {
        qrToolTip = "This option is always enabled due to the project requirements for certain files.";
      } else {
        qrToolTip = "This option is always enabled due to the project requirements.";
      }
    }

    const config: {
      ["label"]: string;
      ["initialValue"]: boolean;
      ["name"]: AdditionalOptions;
      ["disabled"]: boolean;
      ["infoToolTip"]?: string;
    }[] = [
      {
        label: "With directories",
        initialValue: downloadOptions.withDirectories,
        name: "withDirectories",
        disabled: filesAmount < 2,
      },
      {
        label: "Add QR code where possible (i.d. there is a PDF version of this file)",
        initialValue: downloadOptions.withQR,
        name: "withQR",
        disabled: !projectsDataStore.functions.includes("FILECHECK"),
        infoToolTip: qrToolTip,
      },
      {
        label: "Download PDF with WebViewer Annotations (if present)",
        initialValue: false,
        name: "withXfdfAnnotations",
        disabled: !projectsDataStore.functions.includes("WEBVIEWER"),
      },
    ];

    if (downloadMode === "ALL") {
      config.push(
        {
          label: "Use PDF copy of a file whenever possible",
          initialValue: downloadOptions.pdfWherePossible,
          name: "pdfWherePossible",
          disabled: false,
        },
        {
          label: "Add watermark where possible (i.d. there is a PDF version of this file)",
          initialValue: downloadOptions.withWatermark,
          name: "withWatermark",
          disabled: false,
        }
      );
    }

    if (userInfoStore.isSysAdmin && projectsDataStore.functions.includes("FILECHECK")) {
      config.push({
        label: "Dummy QR Test",
        initialValue: false,
        name: "qrTestReport",
        disabled: false,
      });
    }

    return (
      <div style={{ display: "flex", height: "100%", flexDirection: "column", justifyContent: "space-between" }}>
        <Row className="mt-1">
          {config.map(({ label, name, initialValue, disabled, infoToolTip }, index) => (
            <Col key={index} className="mb-sm fullWidth">
              <Switch disabled={disabled} onChange={() => onChange(name)} defaultChecked={initialValue} />
              <span className="ml-sm">{t(label)}</span>
              {typeof infoToolTip === "string" ? (
                <Tooltip title={t(infoToolTip)}>
                  <FontAwesomeIcon icon={["far", "info-circle"]} color="#0fb9b1" style={{ marginLeft: "5px" }} />
                </Tooltip>
              ) : (
                ""
              )}
            </Col>
          ))}
        </Row>
        <Row justify="space-between">
          <Button onClick={onBack}>{t("Back")}</Button>
          <Button onClick={onDone}>{t("Done")}</Button>
        </Row>
      </div>
    );
  })
);
